import React from 'react';
import { CrackIcon, AlertIcon, PriceTagIcon } from './icons';
const costs = [{
  icon: PriceTagIcon,
  stat: '$5K–$10K',
  label: 'Lost home value',
  body: 'A neglected pool is a red flag to buyers, appraisers, and your own guests.'
}, {
  icon: CrackIcon,
  stat: '$4K → $15K',
  label: 'A plaster job becomes a rebuild',
  body: 'Water leaks deeper into the cracks every season and structural damage spreads.'
}, {
  icon: AlertIcon,
  stat: '47 contractors',
  label: 'And no idea who is honest',
  body: 'One quotes $6,000, another $22,000. Half of them aren\u2019t even licensed.'
}];
export function ProblemSection() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-493" data-mp="3jfjwdfk0dcs9">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-494" data-mp="3egh1up1nmoyj">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] lg:gap-20" data-id="element-495" data-mp="3eew5quzoyxyk">
          <div data-id="element-496" data-mp="1p2ati6lywpiz">
            <h2 className="max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-497" data-mp="1p3vp7zk0qeif">
              Your pool used to be the pride of your backyard.
            </h2>
            <div className="mt-6 max-w-2xl space-y-5 text-lg leading-relaxed text-navy-500" data-id="element-498" data-mp="oc7wddiy47h8">
              <p data-id="element-499" data-mp="sdtfvhpzjk0e">
                You remember the day you decided to invest in it — summer parties, family laughs,
                that perfect oasis right outside your door. But somewhere between then and now, the
                plaster cracked. The color faded. Maybe the tile started to slip.
              </p>
              <p data-id="element-500" data-mp="172futibpa9r3">
                Now when friends come over, you find yourself avoiding the backyard. You&apos;re
                thinking about the work, the expense, and the risk of hiring the wrong contractor.
              </p>
              <p className="border-l-2 border-sky-400 pl-5 text-navy-800" data-id="element-501" data-mp="1g22wm58cdhko">
                They disappear mid-project. They quote you $12,000 and suddenly it&apos;s $18,000.
                They&apos;re not licensed. They&apos;re not insured. And when something goes wrong —
                and it does — you&apos;re left holding the bag.
              </p>
              <p className="font-display text-xl font-bold text-navy-800" data-id="element-502" data-mp="k15xeayj9a8o">
                That&apos;s not how this works at A&amp;J.
              </p>
            </div>
          </div>

          <div className="lg:pt-2" data-id="element-503" data-mp="xym3flcx31zw">
            <p className="text-sm font-semibold text-sky-600" data-id="element-504" data-mp="tz3t1jiq29bb">The real cost of waiting</p>
            <ul className="mt-6 space-y-6" data-id="element-505" data-mp="17yla1cps0ia4">
              {costs.map(cost => <li key={cost.label} className="flex gap-4 border-b border-navy-100 pb-6 last:border-0 last:pb-0" data-id="element-506" data-mp="17x1x9w3bwpd3">
                  <cost.icon className="mt-1 h-6 w-6 shrink-0 text-navy-400" data-id="element-507" data-mp="1hoy3jufkjlse" />
                  <div data-id="element-508" data-mp="1hr0r87t912ty">
                    <p className="font-display text-2xl font-bold tracking-tight text-navy-800" data-id="element-509" data-mp="1cq3c643jcowo">
                      {cost.stat}
                    </p>
                    <p className="mt-0.5 text-sm font-semibold text-navy-700" data-id="element-510" data-mp="1qq5o79p5wo40">{cost.label}</p>
                    <p className="mt-1.5 text-sm leading-relaxed text-navy-400" data-id="element-511" data-mp="1ls47uwj4f2w8">{cost.body}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}